import { render, staticRenderFns } from "./reseller-transfer-panel.vue?vue&type=template&id=798c006a&scoped=true"
import script from "./reseller-transfer-panel.vue?vue&type=script&lang=js"
export * from "./reseller-transfer-panel.vue?vue&type=script&lang=js"
import style0 from "./reseller-transfer-panel.vue?vue&type=style&index=0&id=798c006a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c006a",
  null
  
)

export default component.exports